@if (selectedItem()) {
  <mat-form-field appearance="fill" class="small-width">
    <mat-label>{{labelName}}</mat-label>
    <input type="text" matInput disabled value="{{selectedItem()?.name}}" >
    <button matIconButton matSuffix
          (click)="editItem()"
          matTooltip="Change {{labelName}}"
          [attr.aria-label]="'Change {{labelName}}'"
          [attr.aria-pressed]="change">
        <mat-icon>close</mat-icon>
      </button>
  </mat-form-field>
} @else {
  @if(hasItems) {
    <app-dynamic-dropdown-view
      [labelName]="labelName"
      [items]="items"
      [overrideId]="overrideId"
      [overrideIdField]="'integrationId'"
      [displayWithFn]="displayItem"
      [itemTemplateFn]="displayItem"
      (itemSelected)="selectItem($event)"
      [noItemsMessage]="noItemsMessage"
    ></app-dynamic-dropdown-view>
  } @else {
    <div class="loading-display" >
      <app-lt-spinner></app-lt-spinner>
    </div>
  }
}

